abstract class Collections {
  public static isEmpty(array: unknown[]): boolean {
    return array == null || array.length == 0;
  }

  public static isNotEmpty(array: unknown[]): boolean {
    return !this.isEmpty(array);
  }

  public static checkAndReturnAsCollection(value: string | undefined) {
    if (value) {
      return [value];
    }
    return [];
  }
}

export default Collections;
